/** Azione secondaria (Salta, Non so, Non ora): bordo, nessun riempimento. */
import type { ButtonHTMLAttributes, ReactNode } from 'react'

export type SecondaryButtonProps = Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'className'> & {
  children: ReactNode
  /** In una riga di pulsanti ognuno prende lo stesso spazio e va a capo se il testo e grande. */
  grow?: boolean
}

export function SecondaryButton({ children, grow = false, type = 'button', ...rest }: SecondaryButtonProps) {
  return (
    <button
      type={type}
      className={[
        'motion-colors min-h-control rounded-control border-2 border-line bg-transparent px-3 py-1.5 text-secondary text-ink disabled:cursor-not-allowed disabled:opacity-60',
        grow ? 'min-w-[5em] flex-1' : 'w-full',
      ].join(' ')}
      {...rest}
    >
      {children}
    </button>
  )
}
